import { hookstate } from "@hookstate/core";

export const IsLoggedInState = hookstate(false);
